import { useSearchParams } from "react-router-dom";
import { Mail, Instagram, MessageCircle, MapPin } from "lucide-react";
import SectionHead from "../components/SectionHead";
import ContactForm from "../components/ContactForm";
import { Reveal } from "../components/motion";
import { CONTACT } from "../data/content";
import { useLang } from "../i18n";

const ContactPage = () => {
    const [params] = useSearchParams();
    const servicioInicial = params.get("servicio") || "";
    const { t } = useLang();
    const c = t.contactPage;

    const channels = [
        {
            icon: MessageCircle,
            label: c.whatsapp,
            value: CONTACT.whatsappDisplay,
            href: `https://wa.me/${CONTACT.whatsapp}`,
            testid: "contact-whatsapp",
        },
        {
            icon: Mail,
            label: c.email,
            value: CONTACT.email,
            href: `mailto:${CONTACT.email}`,
            testid: "contact-email",
        },
    ];

    return (
        <main className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <SectionHead
                        eyebrow={t.contact.eyebrow}
                        title={t.contact.title}
                        sub={t.contact.sub}
                        testid="contact-page-title"
                    />
                    <div className="mt-8 space-y-4">
                        {channels.map(({ icon: Icon, label, value, href, testid }) => (
                            <Reveal key={label}>
                                <a
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={testid}
                                    className="flex items-center gap-4 rounded-[1.25rem] border border-[#E3DCCF] bg-white p-4 transition-[border-color,transform] duration-200 hover:border-terracotta/50 hover:-translate-y-0.5"
                                >
                                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                                        <Icon size={19} />
                                    </span>
                                    <span>
                                        <span className="block text-xs font-bold uppercase tracking-wider text-[#7C877E]">{label}</span>
                                        <span className="block text-[15px] font-semibold text-ink">{value}</span>
                                    </span>
                                </a>
                            </Reveal>
                        ))}
                        <Reveal>
                            <a
                                href={CONTACT.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-instagram"
                                className="flex items-center gap-4 rounded-[1.25rem] border border-[#E3DCCF] bg-white p-4 transition-[border-color,transform] duration-200 hover:border-terracotta/50 hover:-translate-y-0.5"
                            >
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                                    <Instagram size={19} />
                                </span>
                                <span>
                                    <span className="block text-xs font-bold uppercase tracking-wider text-[#7C877E]">{c.instagram}</span>
                                    <span className="block text-[15px] font-semibold text-ink">{CONTACT.instagramHandle}</span>
                                </span>
                            </a>
                        </Reveal>
                        <Reveal>
                            <div className="flex items-center gap-4 rounded-[1.25rem] bg-olive-light/60 p-4">
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-olive">
                                    <MapPin size={19} />
                                </span>
                                <span>
                                    <span className="block text-xs font-bold uppercase tracking-wider text-olive-dark/70">{c.zona}</span>
                                    <span className="block text-[15px] font-semibold text-olive-dark">{c.zonaValue}</span>
                                </span>
                            </div>
                        </Reveal>
                    </div>
                </div>

                <Reveal delay={0.1} className="lg:col-span-7">
                    <div className="rounded-[2rem] border border-[#E3DCCF] bg-white p-6 shadow-sm sm:p-9">
                        <ContactForm key={servicioInicial} servicioInicial={servicioInicial} />
                    </div>
                </Reveal>
            </div>
        </main>
    );
};

export default ContactPage;
